import { t } from '../../app/i18n';

export default {
  PAID: 'PAID',
  UNPAID: 'UNPAID',
};

export const translation = {
  PAID: t('Zaplatená'),
  UNPAID: t('Nezaplatená'),
};



// WEBPACK FOOTER //
// ./src/common/enums/installmentStatus.js